import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-ventas-entidad',
  templateUrl: './list-ventas-entidad.component.html',
  styleUrls: ['./list-ventas-entidad.component.scss']
})
export class ListVentasEntidadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
